import type { SvgIconProps } from "@mui/material";
import { Images } from "@shared/constants/Images";

export type ExternalIconProps = SvgIconProps & {
  iconPath?: string;
  alt?: string;
};

export const ExternalIcon = ({
  iconPath = Images.icons.common.external,
  alt = "external-icon",
  ...props
}: ExternalIconProps) => {
  return (
    <img
      src={iconPath}
      alt={alt}
      width={props.width || 16}
      height={props.height || 16}
      aria-label={alt}
    />
  );
};
